import { listEmptyStateIntlIds } from './list-empty-state.ids';

export const listEmptyStateLangPtBr = {
  [listEmptyStateIntlIds.title]: `{status, select,
    assigned {Opa! Nenhuma vaga foi reservada ou atribuída ainda}
    not_assigned {Opa! Nenhuma vaga por aqui no momento}
    other {}
  }`,
  [listEmptyStateIntlIds.description]: `{status, select,
    assigned {Assim que uma pessoa Rider reservar ou for atribuída a uma vaga, ela aparece aqui, beleza?}
    not_assigned {Quando novas vagas forem criadas para este hub, elas vão aparecer aqui, beleza?}
    other {}
  }`,

  [listEmptyStateIntlIds.filteredList.title]:
    'Ops! Não encontramos nenhuma vaga com os filtros aplicados',
  [listEmptyStateIntlIds.filteredList.description]:
    'Revise os filtros aplicados ou limpe-os e tente novamente',
  [listEmptyStateIntlIds.filteredList.clearFiltersButton.label]: 'Limpar busca',
};
